/// <amd-module name="VSSUI/Tooltip" />
export * from "./Components/Tooltip";
export * from "./Components/TooltipHost";
export { TooltipDelay, DirectionalHint, TooltipOverflowMode, ITooltipHostProps, ITooltipProps } from "OfficeFabric/Tooltip";
